import { Dispatch } from 'redux';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import CrudActionContainer from './CrudActionContainer';
import LeadAssignmentsController from '../controllers/LeadAssignmentsController';
import { LeadAssignment } from '../interfaces/leadAssignments';
import { getActionHookBuilder } from './action-hook-builder';

class LeadAssignmentsCRUDActions extends CrudActionContainer {
  retrieveAgentGroupsAction: string;
  resetAction: string;

  constructor() {
    super('LEAD_ASSIGNMENTS');

    this.resetAction = super.makeActionKey('RESET');
    this.retrieveAgentGroupsAction = super.makeActionKey(
      'RETRIEVED_AGENT_GROUPS',
    );
  }

  retrieveAll(botId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));
      try {
        const response = await LeadAssignmentsController.getAll(botId);
        const { leadAssignments } = response;
        dispatch(this.retrievedAll(leadAssignments));
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  create(botId: number, params: Partial<LeadAssignment>) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));
      try {
        const response = await LeadAssignmentsController.create(botId, params);
        dispatch(leadAssignmentsCRUDActions.retrieveAll(botId));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  update(
    botId: number,
    leadAssignmentId: number,
    params: Partial<LeadAssignment>,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.updateAction));

      try {
        const response = await LeadAssignmentsController.update(
          botId,
          leadAssignmentId,
          params,
        );
        dispatch(leadAssignmentsCRUDActions.retrieveAll(botId));
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  delete(botId: number, leadAssignmentId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.deleteAction));

      try {
        const response = await LeadAssignmentsController.deleteLeadAssignment(
          botId,
          leadAssignmentId,
        );
        dispatch(leadAssignmentsCRUDActions.retrieveAll(botId));
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }
  reset() {
    return {
      type: this.resetAction,
    };
  }
}

const leadAssignmentsCRUDActions = new LeadAssignmentsCRUDActions();

export const useLeadAssignmentsCRUDActions = getActionHookBuilder(
  leadAssignmentsCRUDActions,
  ['retrieveAll', 'reset', 'create', 'update', 'delete'],
);

export default leadAssignmentsCRUDActions;
